import { useState } from "react";
import { ShoppingCart } from "lucide-react";
import { useAuth } from "../../../context/AuthContext";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../../components/ui/tabs";
import { SUB_TAB_TRIGGER } from "./shared";
import Panoramica from "./Panoramica";
import RichiesteFarmacia from "./RichiesteFarmacia";
import RicetteMedico from "./RicetteMedico";
import ImpostazioniRicette from "./ImpostazioniRicette";
import OrdiniProdotti from "./OrdiniProdotti";

export default function RicetteIA({ token }) {
  const { activeStruttura } = useAuth();
  const [activeSubTab, setActiveSubTab] = useState("panoramica");

  return (
    <div className="space-y-5 -mt-1">
      <Tabs value={activeSubTab} onValueChange={setActiveSubTab}>
        <TabsList className="w-full h-auto flex overflow-x-auto bg-transparent border-b border-slate-200 p-0 rounded-none shadow-none gap-1 mb-5">
          <TabsTrigger value="panoramica" className={SUB_TAB_TRIGGER}>
            Panoramica
          </TabsTrigger>
          <TabsTrigger value="richieste" className={SUB_TAB_TRIGGER}>
            Richieste farmacia
          </TabsTrigger>
          <TabsTrigger value="ricette" className={SUB_TAB_TRIGGER}>
            Ricette da medico
          </TabsTrigger>
          <TabsTrigger value="ordini" className={`${SUB_TAB_TRIGGER} hidden lg:flex`}>
            <ShoppingCart className="w-4 h-4 mr-1.5 shrink-0" />
            Ordina prodotti
          </TabsTrigger>
          <TabsTrigger value="impostazioni" className={SUB_TAB_TRIGGER}>
            Impostazioni
          </TabsTrigger>
        </TabsList>

        <TabsContent value="panoramica" className="mt-0"><Panoramica token={token} onNavigate={setActiveSubTab} /></TabsContent>
        <TabsContent value="richieste" className="mt-0"><RichiesteFarmacia token={token} /></TabsContent>
        <TabsContent value="ricette" className="mt-0"><RicetteMedico token={token} /></TabsContent>
        <TabsContent value="ordini" className="mt-0">
          <OrdiniProdotti token={token} reloadKey={activeStruttura?.id} />
        </TabsContent>
        <TabsContent value="impostazioni" className="mt-0"><ImpostazioniRicette token={token} /></TabsContent>
      </Tabs>
    </div>
  );
}
